/** Must match server upload limit (see UPLOAD_MAX_MB on Render / .env). */
export const MAX_UPLOAD_MB = 25;
export const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;
